import * as v from 'valibot';

export const askQuestionSchema = v.object({
  status: v.string(),
});
